import { Flex } from '@chakra-ui/react'

export function Layout({ children }) {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      fontFamily={'Open Sans, sans-serif!important'}
      fontSize="14px"
      mx="auto"
      maxWidth={'1534px'}
      gap={8}
    >
      {children}
    </Flex>
  )
}
